import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { getDiscount } from '@shared/jp/discount/utils';
import { DiscountService } from '@studiobuki/web-core/lib/discount';
import type { IPreviewCommon } from '@shared/common/data/products';

@Component({
  selector: 'app-item[product]',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductComponent {
  @Input() product!: IPreviewCommon | Readonly<IPreviewCommon>;

  @Output() buttonClick = new EventEmitter<void>();

  public readonly getDiscount = getDiscount;

  constructor(public discountService: DiscountService) {}

  public onButtonClick() {
    this.buttonClick.emit();
  }
}
